module.exports = __webpack_public_path__ + "c1c6b02e77b8939143a936a0fc80f828.svg";